// import download from 'downloadjs'
import { DATASOURCES, CLEAR_STATE } from '../../constants'
import { getDataSource, getSingleReportPdf, putUpdateReports } from '../../store/appReducer'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'ReportFile.'
export const UPDATE_SELECTED_REPORT_ID = `${PREFIX}UPDATE_SELECTED_REPORT_ID`
export const UPDATE_PHYSICIAN_TEMP_COMMENT = `${PREFIX}UPDATE_PHYSICIAN_TEMP_COMMENT`
export const UPDATE_PHYSICIAN_COMMENT = `${PREFIX}UPDATE_PHYSICIAN_COMMENT`
export const UPDATE_SELECTED_POPOVER = `${PREFIX}UPDATE_SELECTED_POPOVER`
export const UPDATE_ESIGN_STEP = `${PREFIX}UPDATE_ESIGN_STEP`
export const DATA_REQUEST = `${PREFIX}DATA_REQUEST`
export const DATA_SUCCESS = `${PREFIX}DATA_SUCCESS`
export const DATA_FAILURE = `${PREFIX}DATA_FAILURE`
export const RESET_STATE = `${PREFIX}RESET_STATE`

export const ESIGN_STEPS = {
  COMMENT_AND_ESIGN: 'COMMENT_AND_ESIGN',
  REPORT_ESIGNED: 'REPORT_ESIGNED',
}

// ------------------------------------
// Actions
// ------------------------------------
export const updateSelectedReportId = id => ({
  type: UPDATE_SELECTED_REPORT_ID,
  payload: id,
})
export const updatePhysicianTempComment = notes => ({
  type: UPDATE_PHYSICIAN_TEMP_COMMENT,
  payload: notes,
})
export const updatePhysicianComment = notes => ({
  type: UPDATE_PHYSICIAN_COMMENT,
  payload: notes,
})
export const updateSelectedPopover = popover => ({
  type: UPDATE_SELECTED_POPOVER,
  payload: popover,
})
export const updateEsignStep = step => ({
  type: UPDATE_ESIGN_STEP,
  payload: step,
})
export const dataRequest = () => ({
  type: DATA_REQUEST,
})
export const dataSuccess = () => ({
  type: DATA_SUCCESS,
})
export const dataFailure = () => ({
  type: DATA_FAILURE,
})
export const resetState = () => ({
  type: RESET_STATE,
})

export const getReportFileData = (forceUpdate = false, getPrerequisiteData) => (dispatch, getState) => {
  dispatch(dataRequest())

  const {
    selectedReportId,
  } = getState().reportFile

  let promises = Promise.resolve()
  if (typeof getPrerequisiteData === 'function') {
    promises = promises
      .then(() => getPrerequisiteData(forceUpdate))
  }

  return promises
    .then(() => dispatch(getSingleReportPdf(selectedReportId)))
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      console.log('getReportFileData', err)
      dispatch(dataFailure())
    })
}

export const checkIsSigned = report => report.esignedAt || report.esignMemberId
export const handleOnEsign = getPrerequisiteData => (dispatch, getState) => {
  dispatch(dataRequest())
  const {
    selectedReportId,
    comment,
  } = getState().reportFile

  let promises = Promise.resolve()
  if (typeof getPrerequisiteData === 'function') {
    promises = promises
      .then(() => getPrerequisiteData())
  }


  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME)
      const reports = getDataSource(getState(), DATASOURCES.REPORTS)
      const report = reports.data.byId[selectedReportId] || {}

      const payload = {
        exported: report.exportedAt !== null,
        esigned: report.esignedAt !== null,
        comments: report.comments ? report.comments : null,
        esignMemberId: report.esignMemberId ? report.esignMemberId : null,
        id: selectedReportId,
      }

      const {
        id,
      } = me.data.profile

      payload.esigned = true
      payload.esignMemberId = id

      payload.comments = comment

      return dispatch(putUpdateReports([ payload ]))
        .then(() => dispatch(getSingleReportPdf(selectedReportId)))
        .then(() => {
          const reportsDataSource = getDataSource(getState(), DATASOURCES.REPORTS)

          const rep = reportsDataSource.data.byId[selectedReportId]
          const com = rep.comments !== null && typeof rep.comments === 'string'
            ? rep.comments
            : ''

          dispatch(updatePhysicianTempComment(com))
          dispatch(updatePhysicianComment(com))

          if (checkIsSigned(rep)) {
            dispatch(updateEsignStep(ESIGN_STEPS.REPORT_ESIGNED))
          }
        })
        .then(() => dispatch(dataSuccess()))
        .catch(err => {
          console.log('handleOnEsign', err)
          dispatch(dataFailure())
        })
    })
}
export const handleOnCommentChange = value => (dispatch, getState) => {
  dispatch(updatePhysicianTempComment(value))
}

export const handleOnCommentBlur = () => (dispatch, getState) => {
  const {
    tempComment,
  } = getState().reportFile

  dispatch(updatePhysicianComment(tempComment))
}

export const handleOnCancelClick = () => (dispatch, getState) => {
  const {
    comment,
  } = getState().reportFile

  dispatch(updateSelectedPopover(null))
  dispatch(updatePhysicianTempComment(comment))
  dispatch(updateEsignStep(initialState.esignStep))
}

export const handleOnSignatureClick = () => (dispatch, getState) => {
  const {
    esignStep,
    tempComment,
  } = getState().reportFile

  dispatch(updatePhysicianComment(tempComment))
  return dispatch(handleOnEsign())
    .then(() => {
      const nextEsignStep = dispatch(getNextEsignStep(esignStep))
      dispatch(updateEsignStep(nextEsignStep))
    })
}

export const handleOnEsignClick = () => (dispatch, getState) => {
  const {
    selectedPopover,
    selectedReportId,
  } = getState().reportFile
  const {
    [DATASOURCES.REPORTS]: reports,
  } = getState().app.dataSources

  const nextPopover = !selectedPopover
  dispatch(updateSelectedPopover(nextPopover))
  if (nextPopover === false) {
    dispatch(handleOnCancelClick())
  } else {
    if (reports.data) {
      const report = reports.data.byId[selectedReportId]
      const comment = report.comments !== null && typeof report.comments === 'string'
        ? report.comments
        : ''

      dispatch(updatePhysicianTempComment(comment))
      dispatch(updatePhysicianComment(comment))

      if (checkIsSigned(report)) {
        dispatch(updateEsignStep(ESIGN_STEPS.REPORT_ESIGNED))
      }
    }
  }
}

export const handleOnAllReportsClick = () => (dispatch, getState) => {
  dispatch(resetState())
}

const getNextEsignStep = step => (dispatch, getState) => {
  let nextStep
  switch (step) {
  case ESIGN_STEPS.COMMENT_AND_ESIGN:
    nextStep = ESIGN_STEPS.REPORT_ESIGNED
    break
  default:
    break
  }

  return nextStep
}

export const handleOnOutsidePopoverClick = () => (dispatch, getState) => {
  dispatch(handleOnCancelClick())
}

export const handleOnNavClick = () => (dispatch, getState) => {
  dispatch(resetState())
}

const initialState = {
  dataIsFetching: false,
  dataLastUpdated: null,
  selectedReportId: '',
  selectedPopover: false,
  comment: null,
  tempComment: '',
  esignStep: ESIGN_STEPS.COMMENT_AND_ESIGN,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_SELECTED_REPORT_ID]: (state, action) => ({
    ...state, selectedReportId: action.payload,
  }),
  [UPDATE_PHYSICIAN_TEMP_COMMENT]: (state, action) => ({
    ...state, tempComment: action.payload,
  }),
  [UPDATE_PHYSICIAN_COMMENT]: (state, action) => ({
    ...state, comment: action.payload,
  }),
  [UPDATE_SELECTED_POPOVER]: (state, action) => ({
    ...state, selectedPopover: action.payload,
  }),
  [UPDATE_ESIGN_STEP]: (state, action) => ({
    ...state, esignStep: action.payload,
  }),
  [RESET_STATE]: (state, action) => ({
    ...initialState,
  }),
  [DATA_REQUEST]: (state, action) => ({
    ...state, dataIsFetching: true,
  }),
  [DATA_SUCCESS]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [DATA_FAILURE]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function reportFileReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/containers/ReportFile/module.js